import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { useInView } from 'react-intersection-observer'

import Content from 'main/Footer/Content'
import Copy from 'main/Footer/Copy'
import Top from 'shared/Top/Top'

const s = {
  container: `relative w-full h-fit-content pt-52 px-0 pb-12 bg-lightwhite`,
  overlay: `absolute top-0 left-0 z-1 w-full h-full bg-black`,
  wrapper: `wrapper`,
}

const Footer = () => {
  const datas = useStaticQuery(graphql`
    query {
      flamelinkFooterContent {
        copy
        description
        info
        links
      }
      allFlamelinkNavContent(
        sort: { fields: _fl_meta____createdDate, order: DESC }
      ) {
        nodes {
          id
          slug
          title
          link
        }
      }
    }
  `)

  const [ref, inView] = useInView({
    threshold: 0.5,
  })

  return (
    <div ref={ref} className={s.container}>
      <div
        className={s.overlay}
        style={{ clipPath: 'polygon(0 7rem, 100% 0, 100% 100%, 0% 100%)' }}
      />

      <div className={s.wrapper}>
        <Content datas={datas} />
        <Copy datas={datas} />

        {inView && <Top />}
      </div>
    </div>
  )
}

export default Footer
